import { useState } from 'react';
import logo from '../../assets/Logo.png';
import logoPhone from '../../assets/logo-width-to600.svg';
import '../SignUp/index.scss';
import EmailIcon from '../../assets/EmailIcon.svg';
import EmailUploadIcon from '../../assets/EmailUploadIcon.svg';
import EmailQuesIcon from '../../assets/EmailQuesIcon.svg';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { Button } from 'antd';

export const EmailConfirmation = () => {
    const navigate = useNavigate();
    const [screenWidth, setScreenWidth] = useState<number>(window.screen.width);
    function handleResize() {
        setScreenWidth(window.screen.width);
    }

    window.addEventListener('resize', handleResize);

    const [searchParams] = useSearchParams();

    const upload_documents = searchParams.get('upload_documents');
    const questionary = searchParams.get('questionary');
    const registration_number_token = searchParams.get('registration_number_token');

    const location = useLocation();

    return questionary ? (
        <div className="email_confirmation">
            <div className="email_confirmation__header header">
                {screenWidth > 600 && <img src={logo} className="header__logo" />}
                {screenWidth <= 600 && <img src={logoPhone} className="header__logo" />}
            </div>
            <div className="email_confirmation__wrapper">
                <img src={EmailQuesIcon} />
                <div className="email_confirmation__title">
                    Email confirmed — action <br /> required to be considered
                </div>
                <div className="email_confirmation__subtitle">
                    To be considered for this opportunity, please review and update your supplier profile. Some required
                    information has changed since your last update.
                    <Button
                        style={{ width: '100%', margin: '24px 0 0 0' }}
                        type="primary"
                        onClick={() => {
                            const questionaryParams = {
                                supplier_company_id: questionary,
                                registration_number_token: registration_number_token ?? null,
                                ...(upload_documents ? { upload_documents } : {})
                            };
                            sessionStorage.setItem('questionary_params', JSON.stringify(questionaryParams));

                            if (upload_documents) {
                                navigate(
                                    `/register/supplier?supplier_company_id=${questionary}&upload_documents=${upload_documents}`
                                );
                            } else {
                                navigate(`/register/supplier`);
                            }
                        }}
                        className=""
                    >
                        Update supplier profile
                    </Button>
                </div>
            </div>
        </div>
    ) : upload_documents ? (
        <div className="email_confirmation">
            <div className="email_confirmation__header header">
                {screenWidth > 600 && <img src={logo} className="header__logo" />}
                {screenWidth <= 600 && <img src={logoPhone} className="header__logo" />}
            </div>
            <div className="email_confirmation__wrapper">
                <img src={EmailUploadIcon} />
                <div className="email_confirmation__title">
                    Email confirmed — upload <br /> documents to be considered
                </div>
                <div className="email_confirmation__subtitle">
                    To be considered for this opportunity, please upload your company documents for verification. This
                    is required before you can participate.
                    <Button
                        style={{ width: '100%', margin: '24px 0 0 0' }}
                        type="primary"
                        onClick={() => {
                            const params = new URLSearchParams(location.search);
                            params.delete('registration_number_token');
                            const query = params.toString();
                            navigate(`/supplier-company/verification${query ? `?${query}` : ''}`);
                        }}
                        className=""
                    >
                        Upload company documents
                    </Button>
                </div>
            </div>
        </div>
    ) : (
        <div className="email_confirmation">
            <div className="email_confirmation__header header">
                {screenWidth > 600 && <img src={logo} className="header__logo" />}
                {screenWidth <= 600 && <img src={logoPhone} className="header__logo" />}
            </div>
            <div className="email_confirmation__wrapper">
                <img src={EmailIcon} />
                <div className="email_confirmation__title">Email address confirmed</div>
                <div className="email_confirmation__subtitle">
                    You have successfully confirmed your email address, and your company has been added to the supplier
                    list for this Matchmaking Journey.
                </div>
                <div className="email_confirmation__add-text">
                    Going forward, you will receive periodic notifications to keep you informed of important updates and
                    next steps.
                </div>
            </div>
        </div>
    );
};
